<form
  *ngIf="!!form"
  [formGroup]="form"
  class="form-row"
>
  <app-date-input
    title="Start Date"
    [formControlNameString]="startDateFieldName"
    [form]="form"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [clearable]="clearable"
    (onDateChange)="emitValue()"
  ></app-date-input>

  <app-date-input
    title="End Date"
    [formControlNameString]="endDateFieldName"
    [form]="form"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [clearable]="clearable"
    (onDateChange)="emitValue()"
  ></app-date-input>
</form>
